import { Link } from "react-router-dom";
import type { Vault } from "../contexts/vault-types";

interface Props {
  vault: Vault;
  tag: string;
  editable?: boolean;
  onRemove?: () => void;
}

export function TagPill({ vault, tag, editable, onRemove }: Props) {
  if (editable) {
    return (
      <span className="inline-flex items-center gap-1 bg-attic-accent-bg text-attic-accent text-xs px-2 py-0.5 rounded-full">
        {tag}
        <button onClick={onRemove} className="text-attic-dim text-[10px]" aria-label={`Remove tag ${tag}`}>×</button>
      </span>
    );
  }
  return (
    <Link to={`/tag/${vault}/${tag}`} className="inline-block bg-attic-accent-bg text-attic-accent text-xs px-2 py-0.5 rounded-full">
      {tag}
    </Link>
  );
}
